// import React, { useRef } from "react";
// import northeasternBg from "../assests/neu.jpg";
// import jssBg from "../assests/jss.jpg";

// const educationData = [
//   {
//     img: northeasternBg,
//     title: "Master's in Information Systems",
//     institution: "Northeastern University, Boston",
//     period: "August 2023 - Present",
//     label: "Graduate",
//     size: "large",
//   },
//   {
//     img: jssBg,
//     title: "B.E. in Computer Science",
//     institution: "JSS, Bangalore",
//     period: "August 2016 - Sep 2020",
//     label: "UnderGraduate",
//     size: "small",
//   },
// ];

// const Education = () => {
//   const educationRef = useRef([]);

//   return (
//     <div className="education-container">
//       {educationData.map(({ img, title, institution, period, label, size }, idx) => (
//         <div
//           key={idx}
//           ref={(el) => (educationRef.current[idx] = el)}
//           className={`education-card ${size}`}
//         >
//           <div className="overlay">
//             <div className="education-top">
//             <div className="details">
//             <div className="education-label">{label}</div>
//             <div className="education-title">{title}</div>
//             </div>
//             <div className="side-grid">
//             <p className="education-institution">{institution}</p>
//               <p className="education-period">{period}</p>
//             </div>
//             </div>

//             <div className="education-content">
//               <div className="education-inside-image">
//                 <img src={img} alt={title} className={label} />
//               </div>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Education;
import React from "react";

const educationData = [
  {
    title: "Master's in Information Systems",
    institution: "Northeastern University, Boston",
    period: "August 2023 - Present",
    label: "Graduate",
  },
  {
    title: "B.E. in Computer Science",
    institution: "JSS Academy of Technical Education, Bangalore",
    period: "August 2016 - Sep 2020",
    label: "Undergraduate",
  },
];

const Education = () => {
  return (
    <div className="timeline-container">
      {educationData.map(({ title, institution, period, label }, idx) => (
        <div key={idx} className={`timeline-item ${idx % 2 === 0 ? "left" : "right"}`}>
          <div className="timeline-content">
            <div className="timeline-header">
              <span className="education-label">{label}</span>
              <span className="education-period">{period}</span>
            </div>
            <h3 className="education-title">{title}</h3>
            <p className="education-institution">{institution}</p>
          </div>
        </div>
      ))}
      <div className="timeline-line"></div>
    </div>
  );
};

export default Education;
